<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" :ref="ref"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" :class="modalSize" role="document">
      <div class="modal-content">
        <div class="modal-header d-flex justify-content-center align-items-center" :class="customHeaderClass">
          <h5 class="modal-title speedee-bold" id="editModalLabel">{{ modalTitle }}</h5>
        </div>
        <div class="modal-body bg-light">
          <slot></slot>
        </div>
        <slot name="footerButtons"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  inheritAttrs: false,
  props: {
    modalTitle: {
      type: String,
      default: 'Modal Title'
    },

    modalSize: {
      type: String,
      default: ''
    },

    id: {
      type: String,
      default: 'editModal'
    },

    customHeaderClass: {
      type: Array,
      default: ['bg-dark']
    }
  },

  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
}
</script>

<!-- <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button> -->
